import { render, staticRenderFns } from "./ChangePassword.vue?vue&type=template&id=4a54738c&"
import script from "./ChangePassword.vue?vue&type=script&lang=js&"
export * from "./ChangePassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4a54738c')) {
      api.createRecord('4a54738c', component.options)
    } else {
      api.reload('4a54738c', component.options)
    }
    module.hot.accept("./ChangePassword.vue?vue&type=template&id=4a54738c&", function () {
      api.rerender('4a54738c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/users/ChangePassword.vue"
export default component.exports